import {
    Box,
    Flex,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import {
    Icon,
    IconsNames,
    Image,
    Sidebar,
    useScrollDirection,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import { NavigationBlock } from 'widgets/navigation-block';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { LuMenu, LuPhone, LuShoppingCart } from 'react-icons/lu';
import { useCart } from 'features';
import { useHeaderState } from '../model/slice';

type HeaderProps = GridProps & React.RefAttributes<HTMLDivElement>

let logoHeight = 97;
let mLogoHeight = 40;

export const Header: React.FC<HeaderProps> = ({
    ...props
}) => {
    const scrollDirection = useScrollDirection();
    const ref = useRef<HTMLDivElement>(null);

    const ref2 = useRef<HTMLDivElement>(null);
    const ref3 = useRef<HTMLDivElement>(null);

    const [open, setOpen] = useState(false);
    const { totalCount } = useCart();

    const {
        phone,
        address,
        email,
        socialMedias,
        logoImage,
    } = useHeaderState();

    if (ref2.current?.getBoundingClientRect().height) {
        logoHeight = ref2.current?.getBoundingClientRect().height;
    }

    if (ref3.current?.getBoundingClientRect().height) {
        mLogoHeight = ref3.current.getBoundingClientRect().height;
    }

    return (
        <Grid
            ref={ref}
            {...props}
            top={
                ref.current && scrollDirection === 'down'
                    ? ref.current.getBoundingClientRect().height * -1
                    : '0px'
            }
            position="sticky"
            zIndex={20}
            background="white"
            transitionProperty="all"
            transitionTimingFunction="cubic-bezier(0.4, 0, 0.2, 1);"
            transitionDuration="0.5s"
        >
            <Grid
                padding={{
                    base: '1rem',
                    lg: '2rem',
                }}
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
                gap="1rem"
                templateColumns={{
                    base: '1fr auto 1fr',
                    lg: 'auto 1fr',
                }}
            >
                <Box
                    ref={ref3}
                    display={{
                        base: 'block',
                        lg: 'none',
                    }}
                    height="fit-content"
                    cursor="pointer"
                    padding="1rem"
                    onClick={() => setOpen(true)}
                >
                    <LuMenu
                        size="2rem"
                    />
                </Box>
                <Box
                    height={{
                        base: `${mLogoHeight}px`,
                        lg: `${logoHeight}px`,
                    }}
                    width={{
                        base: 'fit-content',
                        lg: '153px',
                    }}
                >
                    <Link
                        to="/"
                    >
                        <Image
                            src={logoImage?.url}
                            height="100%"
                            width="100%"
                            objectFit="contain"
                        />
                    </Link>
                </Box>
                <Grid
                    gap="1rem"
                    ref={ref2}
                    height="fit-content"
                    scrollbar="hidden"
                    display={{
                        base: 'none',
                        lg: 'grid',
                    }}
                >
                    <Grid
                        templateColumns="1fr auto"
                        gap="2rem"
                    >
                        <Grid
                            templateColumns="auto auto 1fr"
                            gap="2rem"
                            margin="auto 0 0 0"
                        >
                            <Grid
                                templateColumns="auto 1fr"
                                gap="0.5rem"
                                height="fit-content"
                            >
                                <Grid
                                    margin="auto 0"
                                >
                                    <Icon
                                        iconName={IconsNames.Phone}
                                    />
                                </Grid>
                                <Text
                                    color="#000000"
                                    fontSize="1rem"
                                    whiteSpace="nowrap"
                                    cursor="pointer"
                                    onClick={() => {
                                        window.location.href = `tel:${phone}`;
                                    }}
                                >
                                    {phone}
                                </Text>
                            </Grid>
                            <Grid
                                templateColumns="auto 1fr"
                                gap="0.5rem"
                                height="fit-content"
                            >
                                <Grid
                                    margin="auto 0"
                                >
                                    <Icon
                                        iconName={IconsNames.Map}
                                    />
                                </Grid>
                                <Text
                                    fontSize="1rem"
                                    whiteSpace="nowrap"
                                >
                                    {address}
                                </Text>
                            </Grid>
                            <Grid
                                templateColumns="auto 1fr"
                                gap="0.5rem"
                                height="fit-content"
                            >
                                <Grid
                                    margin="auto 0"
                                >
                                    <Icon
                                        iconName={IconsNames.Mail}
                                    />
                                </Grid>
                                <Text
                                    fontSize="1rem"
                                    whiteSpace="nowrap"
                                >
                                    {email}
                                </Text>
                            </Grid>
                        </Grid>
                        <Flex
                            flexDirection="row"
                            gap="1rem"
                            margin="auto 0 0 auto"
                        >
                            {socialMedias.map(({ image, link }) => (
                                <Link to={link}>
                                    <Image
                                        src={image.url}
                                        aspectRatio="1/ 1"
                                        objectFit="contain"
                                        height="1.5rem"
                                        width="1.5rem"
                                        margin="auto 0 0 0"
                                    />
                                </Link>
                            ))}
                        </Flex>
                    </Grid>
                    <Box
                        height="1px"
                        background="#000000"
                    />
                    <Grid
                        templateColumns="1fr auto 3fr auto 3fr auto 1fr"
                        gap="1rem"
                    >
                        <Box
                            height="fit-content"
                            margin="auto auto auto 0"
                            onClick={() => setOpen(true)}
                            cursor="pointer"
                            color="black"
                            transition="0.25s"
                            _hover={{
                                color: '#E74C3C',
                            }}
                        >
                            <LuMenu
                                size="1.25rem"
                            />
                        </Box>
                        <Grid margin="auto 0">
                            <Link
                                to="/catering"
                            >
                                <Text
                                    fontSize="1.25rem"
                                    whiteSpace="nowrap"
                                    width="fit-content"
                                    borderBottom="2px solid transparent"
                                    transition="0.25s"
                                    _hover={{
                                        borderBottom: '2px solid #E74C3C',
                                        color: '#E74C3C',
                                    }}
                                >
                                    Кейтеринг
                                </Text>
                            </Link>
                        </Grid>
                        <Grid margin="auto 0">
                            <Link
                                to="/delivery"
                                viewTransition
                            >
                                <Text
                                    fontSize="1.25rem"
                                    whiteSpace="nowrap"
                                    width="fit-content"
                                    margin="0 auto"
                                    borderBottom="2px solid transparent"
                                    transition="0.25s"
                                    _hover={{
                                        borderBottom: '2px solid #E74C3C',
                                        color: '#E74C3C',
                                    }}
                                >
                                    Доставка блюд
                                </Text>
                            </Link>
                        </Grid>
                        <Grid margin="auto 0">
                            <Link
                                to="/culinary-studio"
                            >
                                <Text
                                    fontSize="1.25rem"
                                    whiteSpace="nowrap"
                                    width="fit-content"
                                    borderBottom="2px solid transparent"
                                    transition="0.25s"
                                    _hover={{
                                        borderBottom: '2px solid #E74C3C',
                                        color: '#E74C3C',
                                    }}
                                >
                                    Кулинарная студия
                                </Text>
                            </Link>
                        </Grid>
                        <Grid margin="auto 0">
                            <Link
                                to="/outdoor-bars"
                            >
                                <Text
                                    fontSize="1.25rem"
                                    whiteSpace="nowrap"
                                    width="fit-content"
                                    margin="0 auto"
                                    borderBottom="2px solid transparent"
                                    transition="0.25s"
                                    _hover={{
                                        borderBottom: '2px solid #E74C3C',
                                        color: '#E74C3C',
                                    }}
                                >
                                    Выездные бары
                                </Text>
                            </Link>
                        </Grid>
                        <Grid margin="auto 0">
                            <Link
                                to="/sweet-shop"
                            >
                                <Text
                                    fontSize="1.25rem"
                                    whiteSpace="nowrap"
                                    width="fit-content"
                                    borderBottom="2px solid transparent"
                                    transition="0.25s"
                                    _hover={{
                                        borderBottom: '2px solid #E74C3C',
                                        color: '#E74C3C',
                                    }}
                                >
                                    Кондитерская
                                </Text>
                            </Link>
                        </Grid>
                        <Grid padding="0.5rem">
                            <Grid margin="0 0 0 auto" position="relative">
                                {totalCount > 0 && (
                                    <Box
                                        position="absolute"
                                        right="-100%"
                                        top="-100%"
                                        padding="0.05rem 0.25rem"
                                        background="#E74C3C"
                                    >
                                        <Text color="white" fontWeight={900} textAlign="center">
                                            {totalCount}
                                        </Text>
                                    </Box>
                                )}
                                <Link to="/cart">
                                    <Box
                                        color="black"
                                        transition="0.25s"
                                        _hover={{
                                            color: '#E74C3C',
                                        }}
                                    >
                                        <LuShoppingCart
                                            size="1.5rem"
                                        />
                                    </Box>
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    display={{
                        base: 'grid',
                        lg: 'none',
                    }}
                    margin="auto 0 auto auto"
                >
                    <Flex
                        flexDirection="row"
                        gap="1rem"
                        margin="auto 0 0 auto"
                    >
                        <Grid
                            margin="auto 0"
                            onClick={() => {
                                window.location.href = `tel:${phone}`;
                            }}
                        >
                            <LuPhone size="2rem" />
                        </Grid>
                        {socialMedias.filter(({
                            showMobile,
                        }) => showMobile).map(({ image, link }) => (
                            <Link to={link}>
                                <Image
                                    src={image.url}
                                    aspectRatio="1/ 1"
                                    objectFit="contain"
                                    width="2rem"
                                    height="100%"
                                    margin="auto 0 0 0"
                                />
                            </Link>
                        ))}
                    </Flex>
                </Grid>
            </Grid>
            <Box height="1px" background="#DDDDDD" />
            <Sidebar
                label="Навигация"
                open={open}
                setOpen={setOpen}
            >
                <Grid
                    height="fit-content"
                >
                    {/* <Link to="/catering">
                        <Text fontSize="2rem">
                            Кейтеринг
                        </Text>
                    </Link>
                    <Link to="/delivery">
                        <Text fontSize="2rem">
                            Доставка блюд
                        </Text>
                    </Link>
                    <Link to="/culinary-studio">
                        <Text fontSize="2rem">
                            Кулинарная студия
                        </Text>
                    </Link>
                    <Link to="/outdoor-bars">
                        <Text fontSize="2rem">
                            Выездные бары
                        </Text>
                    </Link>
                    <Link to="/sweet-shop">
                        <Text fontSize="2rem">
                            Кондитерская
                        </Text>
                    </Link> */}
                    <NavigationBlock />
                </Grid>
            </Sidebar>
            {/* <Grid padding="1rem" background="#E74C3C" /> */}
        </Grid>
    );
};
